import { combineReducers, createStore } from 'redux';
import commonMiddleware from '../middleware';
import airmeet from './airmeet';
import airmeetRecorder from './airmeetRecorder';
import auth from './auth';
import UIBanner from './banner';
import blockUserModal from './blockUserModal';
import bookmarkedSessions from './bookmarkedSessions';
import booth from './booth';
import breakout from './breakout';
import browserNotification from './BrowserNotification';
import {
    AirmeetStatus,
    CreateAirmeet,
    isCustomMedia,
    IsScreenShare,
} from './channel';
import closedCaptions from './closedCaptions';
import cmDashboard from './cmDashboard';
import tickets from './cmDashboard/tickets';
import Community from './Community';
import customReception from './customReception';
import DmNotifications from './DmNotifications';
import dndUsers from './DndUsers';
import emailLogin from './emailLogin';
import emailSignup from './emailSignup';
import emailVerification from './emailVerification';
import FileUploader from './FileUploader';
import forgotPassword from './forgotPassword';
import genral from './genral';
import groupMeeting from './groupMeeting';
import HandRaised from './HandRaised';
import integrationTab from './integrationTab';
import inviteTableDndUsers from './inviteTableDndUsers';
import layout from './layout';
import leaderboard from './Leaderboard';
import leads from './leads';
import leaveTable from './leaveTable';
import liveAirmeet from './liveAirmeet';
import liveAnnouncement from './liveAnnouncement';
import Login from './login';
import lounge from './Lounge';
import MainNavigation from './MainNavigation';
import meetingList from './MeetingList';
import meteredPricing from './meteredPricing';
import onboarding from './onboarding';
import onlineUsers from './onlineUsers';
import PeopleSearch from './peopleSearch';
import profile from './profile';
import recordedVideo from './recordedVideo';
import RHS from './RHS';
import scheduleMeeting from './ScheduleMeeting';
import SocialLounge from './SocialLounge';
import Ticketing from './ticketing';
import toasts from './toasts';

const cReducer = combineReducers({
    auth,
    airmeet,
    AirmeetStatus,
    browserNotification,
    Community,
    CreateAirmeet,
    FileUploader,
    genral,
    HandRaised,
    IsScreenShare,
    lounge,
    Login,
    SocialLounge,
    toasts,
    layout,
    airmeetRecorder,
    liveAirmeet,
    emailLogin,
    emailSignup,
    emailVerification,
    forgotPassword,
    cmDashboard,
    isCustomMedia,
    integrationTab,
    recordedVideo,
    booth,
    tickets,
    UIBanner,
    Ticketing,
    closedCaptions,
    meteredPricing,
    customReception,
    scheduleMeeting,
    meetingList,
    dndUsers,
    leads,
    onlineUsers,
    onboarding,

    bookmarkedSessions,

    DmNotifications,
    profile,
    leaderboard,
    MainNavigation,
    RHS,
    liveAnnouncement,

    inviteTableDndUsers,
    groupMeeting,

    breakout,
    leaveTable,
    PeopleSearch,
    blockUserModal,
});

const getStore = () => {
    return commonMiddleware()(createStore);
};

const store = getStore()(
    cReducer,
    process.env.NODE_ENV === 'development' &&
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true, traceLimit: 25 })
);

export default store;
